import * as React from 'react';

var _path, _path2, _defs;
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var SvgBlog = function SvgBlog(props) {
    return /*#__PURE__*/ React.createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none",
        viewBox: "0 0 80 80"
    }, props), _path || (_path = /*#__PURE__*/ React.createElement("path", {
        fill: "url(#paint0_linear_247_25586)",
        fillOpacity: 0.16,
        d: "m16.038 68.885 8.218-8.218h45.129q1.92 0 3.268-1.347T74 56.05V18.615q0-1.92-1.347-3.268T69.385 14h-50.77q-1.92 0-3.268 1.347T14 18.615V68.18q0 .72.76.971.759.253 1.278-.266"
    })), _path2 || (_path2 = /*#__PURE__*/ React.createElement("path", {
        fill: "url(#paint1_linear_247_25586)",
        d: "m20.256 56.667-8.218 8.218q-.519.52-1.278.266Q10 64.9 10 64.18V14.615q0-1.92 1.347-3.268T14.615 10h50.77q1.92 0 3.268 1.347T70 14.615v37.436q0 1.921-1.347 3.269-1.347 1.347-3.268 1.347zm-3.077-2.564h48.206q.769 0 1.41-.641.64-.642.64-1.41V14.614q0-.768-.64-1.41-.641-.64-1.41-.64h-50.77q-.768 0-1.41.64-.64.642-.64 1.41v44.103zM40 40.558l5.968 3.647q.666.417 1.27-.083.6-.5.435-1.27l-1.596-6.692 5.263-4.493q.602-.584.34-1.263-.263-.68-.962-.776l-6.95-.621-2.665-6.321Q40.793 22 40.012 22t-1.115.686l-2.666 6.32-6.949.622q-.7.096-.962.776t.34 1.263l5.263 4.493-1.596 6.693q-.167.768.436 1.269.603.499 1.27.083z"
    })), _defs || (_defs = /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("linearGradient", {
        id: "paint0_linear_247_25586",
        x1: 14.627,
        x2: 73.165,
        y1: 41.617,
        y2: 41.617,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#B090F5"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#1AA3FF"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "paint1_linear_247_25586",
        x1: 10.627,
        x2: 69.165,
        y1: 37.617,
        y2: 37.617,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#B090F5"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#1AA3FF"
    })))));
};

export { SvgBlog as ReactComponent };
//# sourceMappingURL=Blog.svg.es.js.map
